module.exports = __webpack_public_path__ + "static/fish-8ce9bfa80f33228438aca1cb912d5d93.webm";